module.exports = require('./helpers/bundle-url').getBundleURL('2i3Nj') + "logo.7718c6df.svg";